import { createClient } from '@supabase/supabase-js';
import { CookieStorage } from './cookieStorage';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

const useCookies =
  import.meta.env.VITE_AUTH_STORAGE === 'cookie' &&
  !!import.meta.env.VITE_AUTH_COOKIE_DOMAIN;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'otto-auth-token',
    ...(useCookies
      ? { storage: new CookieStorage(import.meta.env.VITE_AUTH_COOKIE_DOMAIN) }
      : {}),
  },
});
